import React from "react"
import ReactDatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { DateToText } from "../lib/dateFormat";
import InputGroup from 'react-bootstrap/InputGroup';
import styles from './datePicker.module.scss';

interface IProps {
    date: string | undefined; // 2000-01-31
    setDate: (newDate: string) => void; // setSate for date from parent component
    placeholder?: string;
    disabled?: boolean;
    isEdited?: boolean;
    onUndo?: () => void;
}

interface IState {
    date: Date | undefined;
}

export class DatePicker extends React.Component<IProps, IState> {
    state = {
        date: this.props.date ? this.parseLocalDate(this.props.date) : undefined
    }

    // Parse date string to local date without timezone adjustment
    parseLocalDate(dateString: string): Date {
        if (!dateString) return undefined;
        
        // Parse YYYY-MM-DD format
        const [year, month, day] = dateString.split('-').map(Number);
        
        // Create date with local timezone (no UTC conversion)
        return new Date(year, month - 1, day);
    }

    // Add componentDidUpdate to handle prop changes
    componentDidUpdate(prevProps: IProps) {
        if (prevProps.date !== this.props.date) {
            this.setState({
                date: this.props.date ? this.parseLocalDate(this.props.date) : undefined
            });
        }
    }

    handleSelect = (d: Date) => {
        const dateStr = DateToText(d);
        this.props.setDate(dateStr);
        this.setState({
            date: d
        })
    }

    handleChange = (d) => {
        const dateStr = DateToText(d);
        this.props.setDate(dateStr);
        this.setState({
            date: d ? d : undefined
        })
    }

    render() {
        const { disabled = false, isEdited = false, onUndo } = this.props;
        
        return (
            <InputGroup 
                style={{
                    backgroundColor: isEdited ? 'var(--bs-warning-bg-subtle)' : 'none'
                }}
            >
                <InputGroup.Text 
                    onClick={disabled ? undefined : (e) => {
                        e.currentTarget.nextElementSibling.getElementsByTagName("input")[0].dispatchEvent(new Event("click", {
                            bubbles: true,
                            cancelable: true,
                        }));
                    }}
                    style={{ 
                        cursor: disabled ? 'not-allowed' : 'pointer',
                        opacity: disabled ? 0.6 : 1,
                        backgroundColor: isEdited ? 'var(--bs-warning-bg-subtle)' : 'none'
                    }}
                >
                    <i className="fa-solid fa-calendar-days" />
                </InputGroup.Text>

                <ReactDatePicker
                    dateFormat="dd/MMM/yyyy"
                    selected={this.state.date}
                    onSelect={disabled ? undefined : this.handleSelect}
                    onChange={disabled ? undefined : this.handleChange}
                    placeholderText={this.props.placeholder ?? null}
                    disabled={disabled}
                    className="text-uppercase"
                />
                
                {isEdited && onUndo && (
                    <InputGroup.Text className={styles.hoverIcon}>
                        <i 
                            className="fa fa-undo hover-icon" 
                            onClick={onUndo}
                            title="Undo changes"
                        />
                    </InputGroup.Text>
                )}
            </InputGroup>
        )
    }
}